import { upperFirst } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import {
  StyledButton,
  StyledH2,
  StyledNarrowWrapper,
  StyledText,
} from '../../../pages/UploadDocuments/UploadDocuments.styles';
import { UPLOAD_DOCUMENTS_FLOW_STEPS } from '../../../shared/constants';
import {
  StyledAddGuarantorButton,
  StyledAddGuarantorButtonText,
  StyledAddGuarantorButtonTitle,
  StyledGuarantorIcon,
  StyledNarrowerContainer,
} from './AddAnotherGuarantorOrFinish.styles';

const AddAnotherGuarantorOrFinish = (): JSX.Element => {
  const { t } = useTranslation(['documentsflow', 'common', 'routes']);

  const navigate = useNavigate();
  const { locale } = useParams();
  const [searchParams] = useSearchParams();
  const bookingId = searchParams.get('booking_id');

  return (
    <StyledNarrowWrapper>
      <StyledH2>{upperFirst(t('youAddedANewGuarantor'))}!</StyledH2>
      <StyledText black>{upperFirst(t('addAllTheGuarantors'))}</StyledText>
      <StyledNarrowerContainer>
        <StyledAddGuarantorButton
          onClick={() => {
            navigate(
              `/${locale}/${t('routes:uploadDocuments')}/${
                UPLOAD_DOCUMENTS_FLOW_STEPS.ADD_A_GUARANTOR
              }?booking_id=${bookingId}`,
            );
          }}
        >
          <div>
            <StyledAddGuarantorButtonTitle>
              {upperFirst(t('addAnotherGuarantor'))}
            </StyledAddGuarantorButtonTitle>
            <StyledAddGuarantorButtonText>
              {upperFirst(t('youWillBeAskedToUploadIncomeDocuments'))}
            </StyledAddGuarantorButtonText>
          </div>
          <StyledGuarantorIcon />
        </StyledAddGuarantorButton>
        <StyledButton
          onClick={() => {
            navigate(
              `/${locale}/${t('routes:uploadDocuments')}/${
                UPLOAD_DOCUMENTS_FLOW_STEPS.WAIT_FOR_CONFIRMATION
              }?booking_id=${bookingId}`,
            );
          }}
          title={upperFirst(t('common:finish'))}
          variant="primary"
        >
          {t('common:finish')}
        </StyledButton>
      </StyledNarrowerContainer>
    </StyledNarrowWrapper>
  );
};

export default AddAnotherGuarantorOrFinish;
